<template>
<div>
            <div class="edit-step">
            <steps :active="3"></steps>
        </div>
 <div id="helpChapter" class="helpChapter app-inner">
    <div class="public-btn-small flex align-cen posta">
            <div class="public-btn-small-plan"  @click="reback" style="margin-left:0">
                上一步
            </div>
            <div class="public-btn-small-primary"  @click="onSubmit" style="margin-left:16px">
                保存
            </div>
            </div>
         <!-- <div class="edit-header flex align-cen">
            <el-button plain @click="reback">上一步</el-button>
             <el-button type="primary" class="mft" @click="onSubmit">保存</el-button>
        </div> -->
        <div class="helpChapter-con edit-from">
        <div class="public-tit flex align-cen">
            <div class="public-tit-list">
                <i class="icon-al-cloudupload-fill"></i>  上传内容
            </div>
        </div>
                <div class="chapter-list" v-if="list.length != 0">
                    <el-collapse v-model="activeNames">
                        <el-collapse-item v-for="(item,index) in list" :key="item.id"  :name="item.id">
                            <template slot="title">
                                <div class="numlist-tit flex align-cen">
                                    <div class="tit-name">
                                        {{item.serialNum}} {{item.name}}
                                    </div>
                                </div>
                            </template>
                            <div v-for="childItem in item.children" :key="childItem.id" class="childrenlist flex align-cen">
                               <div class="childrenlist-tit">
                                 {{childItem.serialNum}} {{childItem.name}}
                               </div>
                               <div class="mft childrenlist-btn">
                                  <el-tooltip class="item" effect="dark" :content="!childItem.content ? '上传内容' : '修改内容'" placement="top-start">
                                        <i class="icon-al-cloudupload-fill"  style="color:#409eff" @click="openpload(item.serialNum,item.name,childItem.serialNum,childItem.name,childItem.id)"
                                        v-if="!childItem.content"
                                        ></i>
                                        <i class="icon-al-edit"  style="color:#409eff" @click="openpload(item.serialNum,item.name,childItem.serialNum,childItem.name,childItem.id)"
                                        v-if="childItem.content"
                                        ></i>
                                        </el-tooltip>
                                         <el-tooltip class="item" effect="dark" content="删除内容" placement="top-start">
                                        <i class="icon-al-delete-fill" style="color:#F56C6C"
                                        v-if="childItem.content"
                                        @click="delContent(childItem.id)"
                                        ></i>
                                        </el-tooltip>
                               </div>
                            </div>
                        </el-collapse-item>
                    </el-collapse>
                </div>
                <div class="none-chapter" v-else>
                    <i class="icon-al-cry-fill"></i>
                    <p>暂无章节</p>
                </div>
        </div>

         </div>
</div>
   
</template>
<script>
import steps from "@/components/steps/index.vue"; //步骤条组件
import LocaStorage from "../../../utils/localstorage.js" //本地存储公共方法
import {edithelpChapter} from "@/api/index/index"  //章节新增修改接口
import {  chapterDetail } from "@/api/index/index"  //帮助基本信息详情
import { chapterList } from "@/api/index/index"  //查询章节列表
import { delChapter } from "@/api/index/index" //删除章节
import {  helpEditor } from "@/api/index/index"  //帮助基本信息详情
export default {
    name:'upContent',
    components: {
        steps,
    },
    data: () =>{
        return {
            list:[],
            total:0,
            totallist:0,
            edittype:0,
            reg:'',
            titname:'添加章节',
            method:'',
            centerDialogVisible:false,
            formLabelAlign:{
                headline:'',
                supportId:'',
                parentId:'0'
            },
            editid:'',
              rules: {
             headline: [
             { required: true, message: '请正确填写标题', trigger: 'blur' },
          ],
        },
        activeNames:[]
        }
    },
  
    created(){

        let token = LocaStorage.setAge().get('token')
        if(token){
            this.headers = {
                'Authorization': token
            }
        }
        if(this.$route.query.id){
            this.$route.meta.title = "编辑章节"
           this.chapterList()
           this.formLabelAlign.supportId = this.$route.query.id
        }else{
            this.$route.meta.title = "新增章节" 
        }
    },
    methods: {
        // 删除编辑内容
        delContent(id){
            this.$confirm('此操作将删除已编辑好的内容, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
              helpEditor({
                id:id,
                content:''
              })
            .then(res => {
               if(res.code == 0){
                this.chapterList()
               }else{
                 this.$message.error(res.msg)
               }
            })
            .catch(err => {
            })
        }).catch(() => {         
        });
        },
        // 下一步
        onSubmit(){
            this.$router.push('/helpList')
        },

        // 删除章节
        deletchapter(type,children,id){
            if(type == 0){
             if(!children){
                this.commdel('章节',id)
            }else{
                this.$message.error('该分类下有子分类，请先删除子分类');
            }
            }else{
               this.commdel('小节',id) 
            }
       
        },
        commdel(name,id){
             this.$confirm('此操作将删除该' + name + ', 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
              delChapter({
                id:id
              })
            .then(res => {
            this.$message({
                type: 'success',
                message: '删除成功!'
            });
            this.chapterList()
            })
            .catch(err => {
            })
        }).catch(() => {         
        });
        },
        // 获取章节列表
        chapterList(){
              chapterList({
                id:this.$route.query.id
              })
            .then(res => {
                if(res.code == 0 && res.data){
                    this.list = res.data
                    this.total = res.data.length
                    for (const key in res.data) {
                        this.activeNames.push(res.data[key].id)
                    }
                }
            })
            .catch(err => {
            })
        },
         // 获取详情
        getDetail(){
              chapterDetail({
                id:this.$route.query.id
              })
            .then(res => {
    
            })
            .catch(err => {
            })
        },
        // 打开上传内容
        openpload(num,name,cnum,cname,cid){
            let params = {
                num:num,
                name:name,
                cnum:cnum,
                cname:cname,
                cid:cid
            }
             this.$router.push({
            name: "upcontentDetail",
            query:{
                id:this.$route.query.id,
                state:this.$route.query.state,
                params:encodeURIComponent(JSON.stringify(params))
            }
           })
        },
        // 返回
        reback(){
          this.$router.push({
            name: "helpChapter",
            query:{
                id:this.$route.query.id,
                state:this.$route.query.state
            }
           })
        },
    }
}
</script>
<style lang="scss" scoped>
#helpChapter{
    height: inherit;
        .posta{
        width: calc(100% - 240px);
        position: absolute;
        background-color: rgb(255, 255, 255);
    box-shadow: rgb(240 240 240) 1px -2px 8px;
    height: 60px;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    position: fixed;
    left: 240px;
    bottom: 60px;
    z-index: 6;
    padding-left: 0;
    }
    .edit-header{
        border-bottom: 1px solid #ccc;
        border-top: 1px solid #ccc;
        padding: 20px;

    }
      .edit-from{
        margin-bottom: 44px;
         .edit-from-tit{
             background: rgb(215, 215, 215);
             padding: 10px 20px;
             font-size: 18px;
         }
          .helpChapter-con-tit{
            padding: 10px 12px;
            background-color:#f7f7f7;
            margin-top: 20px;
            position: relative;
            .tit-ribbon{
                padding-left: 8px;
            }
            .tit-ribbon::before{
                content: '';
                background-color: #155bd4;
                width: 3px;
                height: 14px;
                position: absolute;
                top: 23px;
                left: 12px;
            }
          }
          .none-chapter{
            text-align: center;
            padding-top: 100px;
            i{
                font-size: 50px;
               
            }
          }
          .numlist-tit{
            padding: 0 14px;
            font-size: 16px;
            width: 100%;
            .mft{
                font-size: 13px;
                color: rgb(21, 91, 212);
                div{
                    cursor: pointer;
                    position: relative;
                }
                div:not(:last-child)::after{
                    content: "|";
                   color: #e5e5e5;
                   padding: 0 5px;
                }
                
            }
          }
          .childrenlist{
            padding: 10px 30px;
            margin-top: 10px;
            background: #f7f8fa;
            .childrenlist-tit{
                font-size: 14px;
            }
            .childrenlist-btn{
                padding-right: 5px;
              i{
                 margin-right: 10px;
                  font-size: 20px;
                  cursor: pointer;
              }
            }
          }
         }
}
    .forminfo{
        p{
            padding-left: 20px;
            color: #000;
        }
     .btn{
    width: 200px;
    height: 50px;
    background-color: #409eff;
    border-radius: 0.1vh;
    border: none;
    color: #fff;
    margin: 20px auto;
    margin-bottom: 0;;
    text-align: center;
    line-height: 50px;
    cursor: pointer;
     }
}
::v-deep{
    .el-collapse-item__wrap{
        border-bottom: none;
    }
}
</style>